

export enum WordsFilteringMode {
	INCLUDE = 'INCLUDE',
	EXCLUDE = 'EXCLUDE'
}


